module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/catalogue/bulk-actions-dropdown/bulk-actions-dropdown.component.scss
// module id = ./src/app/catalogue/bulk-actions-dropdown/bulk-actions-dropdown.component.scss
// module chunks = main